// extracted by mini-css-extract-plugin
export default {"app":"styles_app__P4iwX","container":"styles_container__6K39E"};